import { agents } from '../../mocks/dashboard';

/**
 * Agent fleet slice. `agents` (mocks/dashboard.js) is the sample seed;
 * useAgents() fetches GET /api/agents on mount and merges server rows by
 * displayId, keeping icon/visual fields from the mock (server supplies
 * status/config/budget/autonomy). `agentsMode` flips to 'live' only on a
 * successful fetch — sample seed + 'sample' otherwise (go-live-readiness
 * §1/§5c2).
 *
 * Keys are namespaced (`agentsMode`, not `mode`): slices merge into one
 * Zustand store and a bare `mode` here would collide with approvalsSlice's.
 *
 * Note: `set` was missing here previously — actions returned partial state
 * that Zustand ignored (silent no-ops). setAgents/updateAgent now call set.
 */
export const createAgentsSlice = (set) => ({
  agents,
  agentsMode: 'sample',

  setAgents: (nextAgents) => set(() => ({
    agents: nextAgents
  })),

  setAgentsMode: (mode) => set({
    agentsMode: mode === 'live' ? 'live' : 'sample'
  }),

  updateAgent: (id, changes) => set((state) => ({
    agents: state.agents.map((agent) => (
      String(agent.id) === String(id)
        ? { ...agent, ...changes }
        : agent
    ))
  }))
});
